/**
 * FloatingWidgetsContainer
 * 
 * Simple container for floating widgets that stacks them vertically
 * in the bottom-right corner using flexbox.
 * 
 * Just render widgets as children - no registration or offset calculations needed.
 */

import { ReactNode } from 'react'

interface FloatingWidgetsContainerProps {
  children: ReactNode
}

export function FloatingWidgetsContainer({ children }: FloatingWidgetsContainerProps) {
  return (
    <div className="floating-widgets-container fixed bottom-20 right-4 z-40 flex flex-col-reverse items-end gap-3 pointer-events-none">
      {children}
    </div>
  )
}

/**
 * Wrapper for individual widgets to restore pointer events
 */
export function FloatingWidget({ children }: { children: ReactNode }) {
  return (
    <div className="floating-widget pointer-events-auto">
      {children}
    </div>
  )
}

